export const GAME_CONSTANTS = {
  TOWER_DISTANCE: 100,
  BASE_SPEED_UNIT: 20, // 20 seconds to cross at speed 5
  MONEY_PER_SECOND: 10,
};